import React, { FC } from "react";

interface CardProps extends React.ComponentProps<"div"> {
  title?: string;
  subtitle?: string;
}

const Card: FC<CardProps> = ({ title, subtitle, children, ...props }) => {
  const { className, ...rest } = props;

  return (
    <div
      className={`px-24 pt-24 pb-32 flex flex-col space-y-24 bg-black text-white rounded-sm w-244 sm:w-258 md:w-300 xlg:w-343 ${
        className ? `${className}` : ""
      }`}
      {...rest}
    >
      <div className="flex flex-col space-y-4">
        <h1>{title}</h1>
        {subtitle && (
          <p className="mt-4 text-dark-white-64 body1">{subtitle}</p>
        )}
      </div>
      {children}
    </div>
  );
};

export default Card;
